import { Pipe, PipeTransform } from "@angular/core";
import { CustomerTaxCategory, DealType, OverdueCategory, PaymentMethod } from "../model";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
    standalone: true,
    name: 'bool',
    pure: true
})
export class BoolPipe implements PipeTransform {

    constructor(protected translateService: TranslateService) {

    }

    transform(value: boolean): string {
        if (value === true) {
            return '✓';
        } else {
            return '-';
        }
    }

}
